module.exports = "/_next/static/images/30194ade99a71c68f620e35634a39897-product-information-lg-1x.jpg.webp";